import { PopupType } from '../../../components/popup/types';
import { CrossOriginCommunication } from '../../../controllers/crossOriginCommunication/CrossOriginCommunicationController';
import { RoundIntegrityWatcher, RoundIntegrityWatcherPhases } from '../../../logger/RoundIntegrityWatcher';
import { autoplayActions } from '../../../store/slices/autoplay/slice';
import { betActions } from '../../../store/slices/bets/slice';
import { gameStateActions } from '../../../store/slices/game/slice';
import { GameStatus } from '../../../store/slices/game/types';
import { popupActions } from '../../../store/slices/popup/slice';
import { computeFreeChipBalance } from '../../../utils/chips';
import { OutgoingMessage } from '../../crossOriginCommunication/types';
import { type GameCommunicationMessageType, MessageName } from '../types';

import { CoreLowBalanceGameCommunicationProcessor } from './CoreLowBalanceGameCommunicationProcessor';

export class CoreBetsOpenGameCommunicationProcessor extends CoreLowBalanceGameCommunicationProcessor {
  public messageName = MessageName.BetsOpen;

  public process(_message: GameCommunicationMessageType): void {
    const state = this.store.getState();

    RoundIntegrityWatcher.setPhase(RoundIntegrityWatcherPhases.BetsOpen);

    CrossOriginCommunication.dispatch(OutgoingMessage.RoundStart, {
      tableId: state.config.tableConfig?.operatorGameId,
    });

    const gameState = state.gameState;
    const balance = gameState.userInfo?.balance;
    const freeChipBalance = computeFreeChipBalance(state.bonusPromotions.activeBonusCampaign?.bonus);
    const bets = state.bets;

    if (this.checkLowBalanceAndUpdateState(balance, freeChipBalance, bets.betLimits)) {
      if (gameState.balanceCheckCount > 3) {
        this.store.dispatch(popupActions.pushPopup(PopupType.InsufficientFunds));
      } else {
        this.store.dispatch(gameStateActions.setBalanceCheckCount(gameState.balanceCheckCount + 1));
      }
    }

    const autoplay = state.autoplay;
    this.checkAutoplayAvailability(balance, bets, autoplay, freeChipBalance);

    this.store.dispatch(gameStateActions.setCurrentGameStatus(GameStatus.PlaceYourBets));
    this.store.dispatch(betActions.resetBetStack());
    this.store.dispatch(betActions.setAcceptedBets([]));
    this.store.dispatch(gameStateActions.resetForNewGame());

    const isBetsOpen =
      gameState.currentStatus === GameStatus.PlaceYourBets || gameState.currentStatus === GameStatus.LastBets;

    if (autoplay.isInProgress && isBetsOpen) {
      this.store.dispatch(autoplayActions.setPendingAutoplayBet(true));
    }
  }
}
